import { render } from "./SprintHeading.vue?vue&type=template&id=6958649b&ts=true"
import script from "./SprintHeading.vue?vue&type=script&lang=ts"
export * from "./SprintHeading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__